exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.footer-text[data-v-75820b62] {\n  text-align: center;\n  white-space: pre-line;\n}\n", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/components/home/HomeFooter.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,sBAAsB;CACvB","file":"HomeFooter.vue","sourcesContent":["\n.footer-text[data-v-75820b62] {\n  text-align: center;\n  white-space: pre-line;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75820b62","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/HomeFooter.vue
// module id = 8q4E
// module chunks = 75